import { cookies } from "../constants";

export const getCookie = (cname: string) => {
	let name = cname + "=";
	let decodedCookie = document.cookie;
	let ca = decodedCookie.split(';');
	for(let i = 0; i <ca.length; i++) {
	  let c = ca[i];
	  while (c.charAt(0) == ' ') {
		c = c.substring(1);
	  }
	  if (c.indexOf(name) == 0) {
		return c.substring(name.length, c.length);
	  }
	}
	return "";
}

export const setCookie = (cname: string, cvalue: string, hours: number = 1) => {
	const d = new Date();
	d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
	let expires = "expires="+d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires +  `;secure;samesite=Lax`;
}

export const deleteCookies = () => {
	cookies.map(cookie => document.cookie = cookie + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;')
};